import { partnerKey } from '@/5_entities/Configuration'
import type { Location } from '@/5_entities/Location'
import { transformBirthDate, transformSex } from '../lib'
import type { User, UserDTO } from './type'

export class UserAdapter implements User {
  public userId: User['userId']
  public sex: User['sex']
  public birthYear: User['birthYear']

  constructor(obj: UserDTO) {
    this.userId = obj.userId
    this.sex = transformSex(obj?.sex)
    this.birthYear = transformBirthDate(obj.birthYear)
  }
}

export class UserDTOAdapter implements UserDTO {
  public userId: UserDTO['userId']
  // public location?: UserDTO['location']
  public sex?: UserDTO['sex']
  public partnerKey: UserDTO['partnerKey']
  public birthYear: UserDTO['birthYear']
  public cityId: UserDTO['cityId']

  constructor(obj: UserDTO | User) {
    this.userId = obj.userId
    // this.location = obj?.location
    this.cityId = 'location' in obj ? this._transformCityId(obj.location) : undefined
    this.sex = obj?.sex || obj?.sex === 0 ? String(obj.sex) : undefined
    this.partnerKey = partnerKey.get()
    this.birthYear = transformBirthDate(obj.birthYear)
  }

  private _transformCityId(location: UserDTO['location']) {
    if (!location) return

    if (typeof location === 'object') return (location as Location).id

    return Number(location)
  }
}
